{
  "welcome": {
    "title": "Selamat datang, {{name}}",
    "title_noName": "Selamat datang ke Rhemn",
    "body": "Apa-apa yang bercahaya akan menunjukkan fungsinya. Terokai mengikut sebarang urutan, bila-bila masa anda mahu.",
    "start": "Mula meneroka",
    "later": "Bukan sekarang"
  },
  "card": {
    "tryIt": "Cuba",
    "takeALook": "Lihat dahulu",
    "pro": "Sebahagian daripada Rhemn Pro",
    "close_aria": "Tutup"
  },
  "pill": {
    "progress": "{{count}} daripada {{total}} diterokai",
    "progress_short": "{{count}}/{{total}}",
    "done": "Selesai",
    "done_aria": "Tamatkan penerokaan",
    "complete": "Semua telah diterokai"
  },
  "sr": {
    "started": "Mod terokai dihidupkan. Butang menunjukkan fungsinya sebelum bertindak.",
    "hint": "Mod terokai. Menunjukkan fungsinya dahulu.",
    "ended": "Mod terokai dimatikan."
  },
  "settings": {
    "row": "Cara Rhemn berfungsi",
    "row_sub": "Sekilas tentang setiap bahagian",
    "row_aria": "Cara Rhemn berfungsi: terokai aplikasi sekali lagi",
    "helpCaption": "Bantuan"
  },
  "steps": {
    "intention": {
      "title": "Niat hari ini",
      "body": "Tulis satu perkara yang paling penting hari ini, dan tandakan apabila selesai."
    },
    "now": {
      "title": "Hari anda, mengikut solat",
      "body": "Rhemn membahagikan hari anda pada setiap solat. Ini menunjukkan baki masa sebelum solat seterusnya, dan apa yang anda rancang untuknya."
    },
    "verse": {
      "title": "Wawasan ayat",
      "body": "Tanya soalan tentang ayat hari ini, baca tafsir ringkas, dan temui ayat dengan tema yang sama."
    },
    "qibla": {
      "title": "Kiblat",
      "body_chrome": "Arah Kaabah dari lokasi anda, dalam darjah dari utara.",
      "body_ios": "Menghala ke Kaabah dari lokasi anda. Hidupkan kompas langsung dan ia mengikut anda semasa anda berpusing."
    },
    "prayer": {
      "title": "Waktu solat",
      "body_chrome": "Lima waktu solat hari ini bagi lokasi anda. Pilih kaedah pengiraan yang diikuti masjid anda.",
      "body_ios": "Solat seterusnya sepintas lalu. Bukanya untuk melihat kelima-lima waktu dan peringatan bagi setiap satu."
    },
    "tasks": {
      "title": "Tugasan",
      "body": "Simpan tugasan anda dalam senarai, dan beri setiap satu tempat di antara waktu solat."
    },
    "notes": {
      "title": "Nota",
      "body_chrome": "Tulis, atau bercakap sahaja. Rhemn menyalin nota suara dan mesyuarat anda, kemudian meringkaskannya.",
      "body_ios": "Tulis, atau bercakap sahaja. Rhemn menukar kata-kata anda kepada nota yang kemas dan ringkas."
    },
    "profile": {
      "title_chrome": "Profil anda",
      "body_chrome": "Tetapan akaun dan privasi anda. Kembali ke sini untuk meneroka Rhemn semula.",
      "title_ios": "Lagi",
      "body_ios": "Ayat disimpan, Kiblat dan tetapan akaun anda. Anda boleh meneroka Rhemn semula dari sini."
    }
  }
}
